import { put, takeEvery } from 'redux-saga/effects';
import * as types from '../actions/actionTypes';
import HttpService from '../../../modules/core/services/HttpService';
import { loadEntitySuccess } from '../actions/entityActions';
import { identity } from '../../core/auth/identityAuth';

function* loadEntity() {
  const response = yield HttpService.Instance.get(
    process.env.REACT_APP_API_URL +
      'entity/' +
      encodeURI(identity['nxt:entity:id'])
  );
  const entity = yield response.json();
  yield put(loadEntitySuccess(entity));
}

function* entitySaga() {
  yield takeEvery(types.LOAD_ENTITY, loadEntity);
}

export default entitySaga;



// WEBPACK FOOTER //
// ./src/modules/core/sagas/entitySaga.tsx